import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "groupKey", "onClick", "scrollTarget"];
import { Button } from 'foundations-components/transitional/components/Button';
import { useDismissTaskCard, useIsTaskCardDismissed } from '../../../contexts/TaskCardsContext';
import { scrollTo } from '../../../utils/browser';
import { jsx as _jsx } from "react/jsx-runtime";
const DismissTaskCardButton = _ref => {
  let {
      children,
      groupKey,
      onClick,
      scrollTarget
    } = _ref,
    remainingButtonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isDismissed = useIsTaskCardDismissed(groupKey);
  const dismissTaskCard = useDismissTaskCard();
  return /*#__PURE__*/_jsx(Button, Object.assign({
    onClick: event => {
      dismissTaskCard(groupKey);
      if (isDismissed && scrollTarget) {
        scrollTo(scrollTarget);
      }
      if (onClick) {
        onClick(event);
      }
    }
  }, remainingButtonProps, {
    children: children
  }));
};
export default DismissTaskCardButton;